// Google Analytics 4 (gtag.js) — loaded dynamically from env so the
// Measurement ID is never hardcoded.
const GA_ID = process.env.REACT_APP_GA_ID;

let initialized = false;

export const initGA = () => {
  if (initialized || !GA_ID || typeof window === "undefined") return;
  initialized = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID);
};

export const gaEvent = (name, params = {}) => {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
};
